module.exports = __webpack_public_path__ + "static/img/1_2_5.1dfbc0fe.jpg";